// Native replacement for the HUE Blog Filter & Search app.
//
// Reads real Shopify tags already rendered on each article card
// (data-tags, pipe-separated) plus the visible title (data-title) and
// filters the existing DOM cards client-side - no page reload, no network
// request, matching HUE's current behavior. The category -> tag-value
// taxonomy itself lives in Liquid (sections/main-blog.liquid) as the single
// source of truth; this component only needs to know which <select> element
// belongs to which category (via data-category) and which cards exist (via
// data-blog-card) - it does not duplicate the taxonomy.
//
// Because filtering reads article.tags live at render time, any future
// recipe tagged with an existing category value is automatically included
// with zero changes here. A brand-new tag word that isn't part of any
// category's option list simply won't have a matching <option> to filter by
// (same behavior as HUE today for tags outside its configured categories).
window['ThemeSection_BlogFilter'] = () => {
  return {
    noResults: false,
    applyFilters() {
      const root = this.$root;
      const selects = root.querySelectorAll('select[data-category]');
      const activeFilters = Array.from(selects)
        .map((select) => select.value)
        .filter((value) => value !== '');

      const searchInput = this.$refs.searchInput;
      const query = searchInput ? searchInput.value.trim().toLowerCase() : '';

      const cards = root.querySelectorAll('[data-blog-card]');
      let visibleCount = 0;

      cards.forEach((card) => {
        const tags = (card.dataset.tags || '').split('|');
        const matchesFilters = activeFilters.every((value) => tags.includes(value));

        const title = (card.dataset.title || '').toLowerCase();
        const matchesQuery = query === '' || title.includes(query);

        const isMatch = matchesFilters && matchesQuery;
        card.style.display = isMatch ? '' : 'none';

        if (isMatch) {
          visibleCount += 1;
        }
      });

      this.noResults = visibleCount === 0;
    },
    resetFilters() {
      this.$root.querySelectorAll('select[data-category]').forEach((select) => {
        select.value = '';
      });

      if (this.$refs.searchInput) {
        this.$refs.searchInput.value = '';
      }

      this.applyFilters();
    },
  };
};
